module.exports = __webpack_public_path__ + "static/media/tenants.6bddc2d4.svg";